import React, { ReactElement } from "react";

export const VinkjeIcon = (): ReactElement => (
  <svg width="76" height="12" viewBox="0 0 76 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M42.8536 3.35353L36.5 9.70708L33.6465 6.85352L34.3536 6.14642L36.5 8.29287L42.1465 2.64642L42.8536 3.35353Z"
      fill="#3B414E"
    />
  </svg>
);